//Produccion
const URI_BACKEND =  'https://surena.ipetik.com';
//Local
//const URI_BACKEND =  'http://localhost:3001'; 
export default URI_BACKEND;